exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h2[data-v-62a2faf9] {\n  margin: 28px 0 24px 0;\n  align-self: flex-start;\n}\n.add-region[data-v-62a2faf9] {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n.input[data-v-62a2faf9],\n.range[data-v-62a2faf9] {\n  margin-bottom: 25px;\n}\n.cancel[data-v-62a2faf9],\n.delete[data-v-62a2faf9] {\n  margin-top: 25px;\n  cursor: pointer;\n}\n.delete[data-v-62a2faf9] {\n  display: inline-block;\n}\n.select[data-v-62a2faf9] {\n  width: 100%;\n  margin-bottom: 20px;\n}", ""]);

// exports
